import { render, staticRenderFns } from "./TipView.vue?vue&type=template&id=2680a0a9&scoped=true&"
import script from "./TipView.vue?vue&type=script&lang=js&"
export * from "./TipView.vue?vue&type=script&lang=js&"
import style0 from "./TipView.vue?vue&type=style&index=0&id=2680a0a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2680a0a9",
  null
  
)

export default component.exports